import { render } from "./EnduserCard.vue?vue&type=template&id=641acd64&scoped=true"
import script from "./EnduserCard.vue?vue&type=script&lang=js"
export * from "./EnduserCard.vue?vue&type=script&lang=js"

import "./EnduserCard.vue?vue&type=style&index=0&id=641acd64&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-641acd64"

export default script